import Cookies from 'js-cookie';

const COOKIE_NAME = 'CheckoutPage.upsell';

/**
 * Stores the upsell session object in a cookie.
 *
 * @param {Object} session The upsell session object with properties:
 * @param {Object} [cookies] Optional cookies object (e.g., from Next.js cookies()).
 *
 * @property {string} session.initialCheckoutId - The ID of the initial checkout.
 * @property {string} session.initialSellerId - The ID of the initial seller.
 * @property {string} session.initialSubscriptionId - The ID of the initial subscription.
 * @property {string} session.initialPaymentId - The ID of the initial payment.
 * @property {string} session.customerId - The ID of the customer.
 * @property {Object} session.upsell - The upsell configuration object.
 */
export default function setUpsellSession(session, cookies) {
  const upsellSessionString = JSON.stringify(session);
  const cookieOptions = {
    expires: 1 / 24, // Expires in 1 hour
    secure: true,
    sameSite: 'None',
    path: '/',
  };

  if (cookies && typeof cookies.set === 'function') {
    cookies.set(COOKIE_NAME, upsellSessionString, cookieOptions);
  } else if (typeof window !== 'undefined') {
    Cookies.set(COOKIE_NAME, upsellSessionString, cookieOptions);
  }
}
